import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent, flexParentCenterCrossAxis, textClip } from "../utilities/Mixin.styles";
const root = {
    ...flexParent("row"),
    ...flexParentCenterCrossAxis,
    overflow: "hidden"
};
const wrapper = {
    display: "flex",
    alignItems: "center",
    width: "100%"
};
const item = {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
    ...textClip("ellipsis")
};
const chevron = {
    display: "inline-block",
    padding: "0px 4px"
};
/**
 * Styles for the SimpleBreadcrumb component using Fluent UI v9
 */ export const useSimpleBreadcrumbStyles = makeStyles({
    root,
    wrapper,
    item,
    chevron
});
